import type { InfiniteScrollInstance } from './types';
import './types';

const dispatchEvents = (eventName: string): void => {
    const newEvent = new Event(eventName);
    window.dispatchEvent(newEvent);
};

const hideElement = (element: HTMLElement | null): void => {
    if (element) {
        element.classList.add('d-none');
    }
};

const showElement = (element: HTMLElement | null): void => {
    if (element) {
        element.classList.remove('d-none');
    }
};

const initTutorialsInfiniteScroll = (): void => {
    const gridContainer = document.querySelector<HTMLElement>('.grid-container');

    if (!gridContainer) {
        return;
    }

    let currentPage = parseInt(gridContainer.dataset.infiniteScrollPage || '1', 10);
    let totalPages = parseInt(gridContainer.dataset.infiniteScrollTotalPages || '1', 10);

    const loadMoreButton = document.getElementById('load-more-tutorials-btn');

    const initializeInfiniteScroll = (): InfiniteScrollInstance | undefined => {
        const nextPage = document.querySelector('.next-page');

        if (!nextPage) {
            return undefined;
        }

        const elem = document.querySelector<HTMLElement>('.grid-container');

        if (!elem) {
            return undefined;
        }

        const scroll = new window.InfiniteScroll(elem, {
            path: '.next-page',
            append: '.tutorials-card-row',
            button: '.load-more-btn',
            status: '.page-load-status',
            scrollThreshold: 600,
        });

        scroll.on('request', () => {
            hideElement(loadMoreButton);
        });

        scroll.on('append', () => {
            dispatchEvents('infinite-scroll-append');
        });

        scroll.on('load', () => {
            if (
                scroll.loadCount % 3 === 0
                && (scroll.loadCount + currentPage) < totalPages
            ) {
                scroll.loadOnScroll = false;
                showElement(loadMoreButton);
            } else {
                scroll.loadOnScroll = true;
                hideElement(loadMoreButton);
            }
        });

        return scroll;
    };

    let infScroll = initializeInfiniteScroll();

    window.Livewire?.on('searchStringChanged', (params: unknown[]) => {
        dispatchEvents('search-complete');
        currentPage = params[0] as number;
        totalPages = params[1] as number;
    });

    window.Livewire?.hook('commit.prepare', () => {
        if (infScroll) {
            infScroll.destroy();
        }
    });

    window.Livewire?.hook('commit', ({ succeed }) => {
        succeed(() => {
            setTimeout(() => {
                const loadMoreTutorialsButton = document.getElementById('load-more-tutorials-btn');
                hideElement(loadMoreTutorialsButton);

                if (infScroll) {
                    infScroll.destroy();
                }

                dispatchEvents('livewire-refresh');

                infScroll = initializeInfiniteScroll();
            }, 100);
        });
    });
};

const initTutorials = (): void => {
    if (typeof window.InfiniteScroll === 'undefined') {
        setTimeout(initTutorials, 50);

        return;
    }

    initTutorialsInfiniteScroll();
};

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initTutorials);
} else {
    initTutorials();
}
